module.exports = __webpack_public_path__ + "img/red-rain-card-bg.4dd28467.png";